// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"194":"component---src-templates-post-tsx","223":"commons","256":"component---src-templates-blog-tsx"}[chunkId] + "-" + {"194":"ae591cf19bc3afc1d4ee","223":"2019ac224bb33b532573","256":"06ff05ab2f2574ff5d6b"}[chunkId] + ".js";
};